export default {
  en: {
    refCode: 'Ref Code',
    contractValidFrom: 'Contract Valid From',
    salePerson: 'Sales Person',
    pleaseSelectSalePerson: 'Please select sale person',
    contractRemark: 'Contract Remark',
    internalNote: 'Internal Note',
    addSignatureInContract: 'Add signature in contract',
    selectedVersion: 'Selected versions',
    latestVersion: 'Latest versions',
    updatedSalePersonMessage: 'This sale person has been updated',
    deletedSalePersonMessage: 'This sale person has been deleted'
  },
  th: {
    refCode: 'รหัสอ้างอิง',
    contractValidFrom: 'ระยะเวลาสัญญา',
    salePerson: 'พนักงานขาย',
    pleaseSelectSalePerson: 'กรุณาเลือกพนักงานขาย',
    contractRemark: 'หมายเหตุ',
    internalNote: 'Internal Note',
    addSignatureInContract: 'เพิ่มลายเซ็นในสัญญา',
    selectedVersion: 'ข้อมูลที่เลือก',
    latestVersion: 'ข้อมูลล่าสุด',
    updatedSalePersonMessage: 'มีการแก้ไขพนักงานขาย',
    deletedSalePersonMessage: 'พนักงานขายถูกลบไปแล้ว'
  }
}
